import { GetInvoicePaymentRecapApiParameter, BankAccountsModel, getBankAccounts, getInvoicePaymentRecap } from "@NA/Services/ADIInvoiceService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { HasOnError, HasOnSuccess, createHandlerChainRunner, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { InvoiceCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = CustomApiHandler< HasOnSuccess & HasOnError, BankAccountsModel>;

export const DispatchBeginLoadBankAccountsList: HandlerType = props => {
    props.dispatch({
        type: "Custom/BeginLoadBankAccountsList",
        parameter:props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getBankAccounts(props.apiParameter);
};

export const CompleteLoadBankAccountsList: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult as any);
        props.dispatch({
            type: "Custom/CompleteLoadBankAccountsList",
            bankAccountResult: props.apiResult
        });
    }
};

export const chain = [DispatchBeginLoadBankAccountsList, PopulateApiParameter, RequestDataFromApi, CompleteLoadBankAccountsList];

const adiGetBankAccountList = createHandlerChainRunner(
    chain,
    "ADIGetBankAccountList",
);
export default adiGetBankAccountList;
